//
// Copyright 2021 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_dxos_keys } from "../keys_pb.js";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/mesh/presence.proto.
 */
export const file_dxos_mesh_presence = /*@__PURE__*/ fileDesc("ChhkeG9zL21lc2gvcHJlc2VuY2UucHJvdG8SEmR4b3MubWVzaC5wcmVzZW5jZSKaAQoJUGVlclN0YXRlEikKC2Nvbm5lY3Rpb25zGAEgAygLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIqCgxpZGVudGl0eV9rZXkYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EioKB3BlZXJfaWQYAyABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SACIAQFCCgoIX3BlZXJfaWRiBnByb3RvMw", [file_dxos_keys, file_google_protobuf_any]);
/**
 * Describes the message dxos.mesh.presence.PeerState.
 * Use `create(PeerStateSchema)` to create a new message.
 */
export const PeerStateSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_presence, 0);
//# sourceMappingURL=presence_pb.js.map